const order = {
  'orderList.title': 'قائمة الطلبات',
  'orderList.api.error.getOrderList': 'فشل في الحصول على قائمة الطلبات',
};

export default order;
